import React from "react";
import { ModalV2, Button, Text, Flex } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";

interface UnassignedProfileWarningModalProps {
  show: boolean;
  onHide: () => void;
  onContinue: () => void;
}

const UnassignedProfileWarningModal: React.FC<UnassignedProfileWarningModalProps> = ({
  show,
  onHide,
  onContinue,
}) => {
  return (
    <ModalV2
      show={show}
      onHide={onHide}
      backdrop={true}
      closeOnClickOutside={false}
      contentClassName={styles.modal}
      title="Warning"
    >
      <ModalV2.Body>
        <Text>
          One or more positions do not have an assigned profile. Progressing the case without a
          profile assigned to the position will not allow Canopy to track a profile to the
          position.
        </Text>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex gap="md" justifyContent="flex-end">
          <Button onClick={onHide} variant="neutral">
            Cancel
          </Button>
          <Button onClick={onContinue} variant="primary" color="green">
            Continue
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};

export default UnassignedProfileWarningModal;
